import type { AssignedTag } from "services/types/assigned-tag.type";

/**
 * Map a curated set of carried-over tags to the `assigned_tags.create` payload
 * applied to the NEW appointment produced by a reschedule. Reschedule POSTs a
 * fresh appointment, so the carried set is purely creates — no diff, no
 * duplication, no omission. Shape mirrors the existing create mapping in
 * appointment-form.component.tsx.
 */
export const buildReschedTransferCreates = (carriedTags: AssignedTag[]) =>
  carriedTags.map((assignedTag) => ({
    tag: assignedTag.tag.id,
    description: assignedTag.description,
    expires_at: assignedTag.expires_at
      ? new Date(assignedTag.expires_at).toISOString()
      : undefined
  }));
